import { type Context, createContext, useContext } from 'react';

import type { AriaLabelingProps } from '../../../core/types/a11y-props.js';

/**
 * @internal
 * Context carrying the consumer-provided aria-labeling props from a chart's
 * public root down to the internal element that owns `role="img"`, without
 * threading them through every component in between.
 */
export const AriaLabelingContext: Context<AriaLabelingProps> =
  createContext<AriaLabelingProps>({});

/**
 * @internal
 */
export const useAriaLabelingContext = () => useContext(AriaLabelingContext);
